var _circle, _path, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiLimaoSlider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8725,
    cy: 10.9672,
    r: 10.2201,
    fill: "#7EC90D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59946 14.9029C6.37596 14.7897 6.10302 14.8792 5.98984 15.1027C5.87666 15.3262 5.96609 15.5991 6.1896 15.7123L6.59946 14.9029ZM15.4426 15.7093C15.6644 15.5928 15.7499 15.3186 15.6334 15.0968C15.5169 14.8749 15.2427 14.7895 15.0209 14.906L15.4426 15.7093ZM6.1896 15.7123C7.5401 16.3962 8.9063 16.903 10.4203 16.9784C11.9398 17.0541 13.5678 16.6936 15.4426 15.7093L15.0209 14.906C13.2625 15.8292 11.7948 16.1386 10.4654 16.0723C9.13058 16.0058 7.8948 15.5589 6.59946 14.9029L6.1896 15.7123Z",
    fill: "#FBFFFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.05675,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0821,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiLimaoSlider);
export default __webpack_public_path__ + "static/media/emojiLimaoSlider.d5bd136775f25571f0d07e40ea5cc8bc.svg";
export { ForwardRef as ReactComponent };